import {$authHost} from "./index";
import {API_ENDPOINTS} from "../utils/urls";


export async function calcTablesGetApi(payeeId?: number | string) {
    try {
        const query = payeeId != null ? `?payeeId=${payeeId}` : '';
        return await $authHost.get(API_ENDPOINTS.CALC_TABLE + query);
    } catch (error: any) {
        return error;
    }
}

export async function calcTableCreateApi(data: any) {
    try {
        return await $authHost.post(API_ENDPOINTS.CALC_TABLE, data);
    } catch (error: any) {
        return error;
    }
}

export async function calcTableUpdateApi(id: number | string, data: any) {
    try {
        return await $authHost.put(API_ENDPOINTS.CALC_TABLE + `/${id}`, data);
    } catch (error: any) {
        return error;
    }
}

export async function calcTableActivateApi(id: number | string) {
    try {
        return await $authHost.put(API_ENDPOINTS.CALC_TABLE + `/${id}/activate`);
    } catch (error: any) {
        return error;
    }
}

export async function calcTableArchiveApi(id: number | string) {
    try {
        return await $authHost.put(API_ENDPOINTS.CALC_TABLE + `/${id}/archive`);
    } catch (error: any) {
        return error;
    }
}

export async function calcTableUnarchiveApi(id: number | string) {
    try {
        return await $authHost.put(API_ENDPOINTS.CALC_TABLE + `/${id}/unarchive`);
    } catch (error: any) {
        return error;
    }
}

export async function calcTableDeleteApi(id: number | string) {
    try {
        return await $authHost.delete(API_ENDPOINTS.CALC_TABLE + `/${id}`);
    } catch (error: any) {
        return error;
    }
}
